import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ReactSwipe from 'react-swipe';

import {
    IconChevronLeft,
    IconChevronRight,
} from '@zillow/constellation';
// components
import { ImageContainer } from 'app/shared/components/photos/ImageContainer';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

// constants
import StringConstants from 'app/shared/constants/StringConstants';
import {
    StyledImageCarousel,
} from './StyledComponents';

class ImageCarousel extends React.Component {
    static contextTypes = {
        brand: PropTypes.string,
    };

    static propTypes = {
        list: PropTypes.array,
        isListingPhotoProcessing: PropTypes.bool,
        isRotating: PropTypes.bool,
        currentSlideIndex: PropTypes.number,
        startSlide: PropTypes.number,
        // actions
        updateCurrentSlideIndex: PropTypes.func,
    };

    static defaultProps = {
        list: [],
        isListingPhotoProcessing: false,
        isRotating: false,
        currentSlideIndex: 0,
        startSlide: 0,
        updateCurrentSlideIndex: () => {},
    };

    constructor(props) {
        super(props);

        // init state
        this.state = {
            list: this.props.list,
            isListingPhotoProcessing: this.props.isListingPhotoProcessing,
            isRotating: this.props.isRotating,
            startSlide: this.props.startSlide,
        };

        // bind
        this.getNexPos = this.getNexPos.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.renderImageList = this.renderImageList.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            startSlide: nextProps.currentSlideIndex, // update with current slide index
            isListingPhotoProcessing: nextProps.isListingPhotoProcessing,
            list: nextProps.list,
            isRotating: nextProps.isRotating,
        });
    }

    getNexPos() {
        const { list } = this.props;

        // the swipe carousel current position is off if list length is < 3
        const minSwipeItemLength = 3;

        return (list.length < minSwipeItemLength) ?
            this.swipeCarousel.getPos() % list.length :
            this.swipeCarousel.getPos();
    }

    keyDownHandler = handler => (e, index) => {
        // 13 === enter 32 === spacebar
        if (e.keyCode === 13 || e.keyCode === 32) {
            handler(index);
        }
    };

    handleNextClick() {
        this.swipeCarousel.next();
        this.props.updateCurrentSlideIndex(this.getNexPos());
    }

    handlePrevClick() {
        this.swipeCarousel.prev();
        this.props.updateCurrentSlideIndex(this.getNexPos());
    }

    renderImageList() {
        const { list } = this.state;

        return (
            list.map((item) => {
                const thumbUrl = item.url ? item.url.replace('http://photo', 'https://photonet') : '';

                return (
                    <ImageContainer
                        key={item.id}
                        className="ImageContainer"
                        image={thumbUrl}
                        isBackgroundImage={false}
                    />
                );
            })
        );
    }

    render() {
        const { brand } = this.context;
        const { isListingPhotoProcessing, isRotating, startSlide } = this.state;

        return (
            <StyledImageCarousel
                className={cx('ImageCarousel', {
                    hpx: brand === StringConstants.UNFORMATTED_BRAND_NAMES.hotpads,
                    zsg: brand === StringConstants.UNFORMATTED_BRAND_NAMES.zillow,
                })}
            >
                <div className="ImageCarousel-Viewport">
                    <div className="ImageCarousel-ImageList-Container">
                        {isRotating ?
                            <SpinnerContainer /> :
                            (
                                <ReactSwipe
                                    className="ImageCarousel-SwipeCarousel"
                                    swipeOptions={{
                                        continuous: true,
                                        startSlide,
                                    }}
                                    ref={(swipeCarousel) => {
                                        this.swipeCarousel = swipeCarousel;
                                    }}
                                >
                                    {this.renderImageList()}
                                </ReactSwipe>
                            )
                        }
                    </div>
                </div>

                <div className="ImageCarousel-actions-container">
                    <IconChevronLeft
                        aria-label="Left Image"
                        tabIndex={0}
                        role="button"
                        className={cx(
                            'Action',
                            'Action-Prev', {
                                disabled: isListingPhotoProcessing,
                            }
                        )}
                        size="md"
                        fontColor="white"
                        onClick={this.handlePrevClick}
                        onKeyDown={this.keyDownHandler(this.handlePrevClick)}
                    />

                    <IconChevronRight
                        aria-label="Right Image"
                        tabIndex={0}
                        role="button"
                        size="md"
                        fontColor="white"
                        className={cx(
                            'Action',
                            'Action-Next', {
                                disabled: isListingPhotoProcessing,
                            }
                        )}
                        onClick={this.handleNextClick}
                        onKeyDown={this.keyDownHandler(this.handleNextClick)}
                    />
                </div>
            </StyledImageCarousel>
        );
    }
}

export default ImageCarousel;
